import { h } from "preact";
import { useContext } from "preact/hooks";

import Comment from "./Comment";
import UserInfoModal from "./UserInfoModal";

import { Context } from "../lib/globalState";

export default function CommentItem({ comment }) {
  const { state } = useContext(Context);

  return (
    <div className="comment-wrapper">
      <Comment comment={comment} />
      {state?.userInfoVisible && state?.isSelected === comment.id && (
        <UserInfoModal />
      )}
    </div>
  );
}
